import React from 'react';

import GenericField from './shared/GenericField';
import TextInputContainer from './text/TextInputContainer';
import { getIcon } from './shared/FormatHelpers';

/**
 * Text field input.
 * @param {string} [label] Label description for field input.
 * @param {string} [initialValue] Field value.
 * @param {function} [handleSave] [async string=>{bool success, string message}] Save changes / return error message.
 */
const Name = ({ icon, initialValue, handleSave, urlLink }) => {

    const syncChanges = async (name) => {
        if (!name || !name.length) {
            return { success: false, message: 'Namnet får inte vara tomt' };
        } else return await handleSave(name);
    };

    const Icon = getIcon(icon);

    return (
        <GenericField className='name'>
            <div className='icon-container'>{Icon}</div>
            <TextInputContainer {...{ initialValue, syncChanges, urlLink }} />
        </GenericField>
    );
};

export default Name;
